import i18next from '../../core/language';

const t = i18next.t.bind(i18next);

export const EMAIL_SENT = t('We just sent you an e-mail.');
export const MSG_UTC = t('UTC time: ');
export const YOUR_ACCOUNT_DATA_SETUP = t('Click here to complete the "Set up data storage" step.');
